<div class="d-flex flex-column h-75 d-flex justify-content-center align-items-center">
  <div class="error-404 mb-3 font-size-150">404</div>
  <a class="text-decoration-none color-black font-size-18" routerLink="/home" i18n="@@app.home_page">Home Page</a>
</div>
